module.exports = __webpack_public_path__ + "img/chores_empty_icon.ba2f58f8.svg";